import React from "react";
import { styled, Grid as GridBase } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export const DeleteIconStyled = styled(DeleteIcon)`
  color: red;
`;

export const GridContainer = styled((props) => (
  <GridBase
    {...props}
    container
    justifyContent={props.justifyContent || "flex-start"}
    alignItems={props.alignItems || "center"}
  />
))``;

export const AcquirerListRootArea = styled((props) => (
  <GridContainer {...props} />
))``;

export const GridItem = styled((props) => <GridBase {...props} item />)`
  &.MuiGrid-item {
    display: flex;
    flex-direction: ${(props) => props.flexDirection || "column"};
    margin: ${(props) => props.margin || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;
